//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_OUDS_COLORS_CATEGORICAL = {
    color: [
        'var(--ouds-charts-color-categorical-tier-1)',
        'var(--ouds-charts-color-categorical-tier-2)',
        'var(--ouds-charts-color-categorical-tier-3)',
        'var(--ouds-charts-color-categorical-tier-4)',
        'var(--ouds-charts-color-categorical-tier-5)',
        'var(--ouds-charts-color-categorical-tier-6)',
        'var(--ouds-charts-color-categorical-tier-7)',
        'var(--ouds-charts-color-categorical-tier-8)',
        'var(--ouds-charts-color-categorical-tier-9)',
        'var(--ouds-charts-color-categorical-tier-10)',
    ],
};
